import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonContent,
    IonGrid,
    IonCol,
    IonRow,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar,
    useIonRouter,
    IonMenuButton
} from '@ionic/react';
import { useState, useEffect } from 'react';
import './View.css';
import {
    peopleOutline,
    barChartOutline,
    analyticsOutline,
    briefcaseOutline
} from 'ionicons/icons';
import Loader from '../components/Loader';

const OrgAdmin = () => {
    const router = useIonRouter();
    const [loading, setLoading] = useState(true);
    const [organizationName, setOrganizationName] = useState('');

    useEffect(() => {
        setLoading(true);
        // Check if user is organization admin
        const roleId = String(sessionStorage.getItem('role_id') || localStorage.getItem('roleId') || '');
        const userId = sessionStorage.getItem('user_id') || localStorage.getItem('userId');
        
        console.log('OrgAdmin Access Check:', { roleId, userId, sessionUserId: sessionStorage.getItem('user_id') });

        if (!userId || roleId !== '2') {
            console.warn('Unauthorized access to OrgAdmin. Redirecting...', { roleId, userId });
            // If they are role 1, maybe they should be in /super-admin instead of login?
            if (roleId === '1') {
                router.push('/super-admin');
            } else {
                router.push('/page/login');
            }
            // Prevent further execution if redirecting
            return;
        }
        
        const orgName = sessionStorage.getItem('organization_name');
        setOrganizationName(orgName || 'Your Organization');

        // Simulate loading for consistency
        setTimeout(() => setLoading(false), 600);
    }, [router]);

    const adminCards = [
        {
            title: 'Members Management',
            description: 'Manage your organization members',
            icon: peopleOutline,
            color: '#4F46E5',
            bgColor: 'linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)',
            iconBg: 'rgba(79, 70, 229, 0.1)',
            route: '/admin/members'
        },
        {
            title: 'Polls Management',
            description: 'Manage organization polls',
            icon: barChartOutline,
            color: '#0891B2',
            bgColor: 'linear-gradient(135deg, #ECFEFF 0%, #CFFAFE 100%)',
            iconBg: 'rgba(8, 145, 178, 0.1)',
            route: '/admin/polls'
        },
        {
            title: 'Analytics',
            description: 'View organization analytics',
            icon: analyticsOutline,
            color: '#059669',
            bgColor: 'linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)',
            iconBg: 'rgba(5, 150, 105, 0.1)',
            route: '/admin/analytics'
        }
    ];

    return (
        <IonPage>
            <IonHeader className="ion-no-border" translucent={true}>
                <IonToolbar className="header-toolbar frosted-header">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/page/view" />
                    </IonButtons>
                    <IonTitle>Organization Admin Panel</IonTitle>
                    <IonButtons slot="end">
                        <IonMenuButton />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding" style={{ background: 'linear-gradient(to bottom, #F8FAFC 0%, #F1F5F9 100%)' }}>
                {loading && <Loader message="Initializing Org Panel..." />}
                <div style={{
                    marginBottom: '32px',
                    textAlign: 'center',
                    padding: '24px',
                    background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
                    borderRadius: '16px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)'
                }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '80px',
                        height: '80px',
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)',
                        marginBottom: '16px',
                        boxShadow: '0 4px 6px rgba(79, 70, 229, 0.2)'
                    }}>
                        <IonIcon
                            icon={briefcaseOutline}
                            style={{ fontSize: '40px', color: '#FFFFFF' }}
                        />
                    </div>
                    <h1 style={{
                        margin: '0 0 8px 0',
                        fontSize: '28px',
                        fontWeight: '700',
                        background: 'linear-gradient(135deg, #1E293B 0%, #475569 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                    }}>
                        {organizationName}
                    </h1>
                    <p style={{
                        color: '#64748B',
                        fontSize: '16px',
                        margin: 0,
                        fontWeight: '500'
                    }}>
                        Organization Admin Dashboard
                    </p>
                </div>

                <IonGrid>
                    <IonRow>
                        {adminCards.map((card, index) => (
                            <IonCol size="12" sizeMd="6" sizeLg="4" key={index}>
                                <IonCard
                                    className="clickable-card"
                                    onClick={() => router.push(card.route)}
                                    style={{
                                        height: '100%',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        background: card.bgColor,
                                        border: 'none',
                                        borderRadius: '16px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
                                        overflow: 'hidden'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)';
                                    }}
                                >
                                    <IonCardContent style={{ padding: '28px' }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            gap: '16px'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '72px',
                                                height: '72px',
                                                borderRadius: '16px',
                                                background: card.iconBg,
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <IonIcon
                                                    icon={card.icon}
                                                    style={{
                                                        fontSize: '36px',
                                                        color: card.color
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <h2 style={{
                                                    margin: '0 0 8px 0',
                                                    fontSize: '20px',
                                                    fontWeight: '700',
                                                    color: '#1E293B',
                                                    letterSpacing: '-0.01em'
                                                }}>
                                                    {card.title}
                                                </h2>
                                                <p style={{
                                                    color: '#64748B',
                                                    fontSize: '14px',
                                                    margin: 0,
                                                    fontWeight: '500',
                                                    lineHeight: '1.5'
                                                }}>
                                                    {card.description}
                                                </p>
                                            </div>
                                            <div style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                color: card.color,
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                marginTop: '4px'
                                            }}>
                                                <span>Access Now</span>
                                                <span style={{ fontSize: '18px' }}>→</span>
                                            </div>
                                        </div>
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        ))}
                    </IonRow>
                </IonGrid>

                <div style={{
                    marginTop: '48px',
                    padding: '24px',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}>
                    <p style={{
                        color: '#94A3B8',
                        fontSize: '14px',
                        margin: 0,
                        fontWeight: '500',
                        letterSpacing: '0.01em'
                    }}>
                        Organization Admin Panel • Manage your organization's data
                    </p>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default OrgAdmin;
